module.exports = __webpack_public_path__ + "static/media/STATREP- Moses Einstein Wakefield.7a3d23bb.pdf";